import React, { useState, useEffect } from 'react';

import { fetchData, getHomePageUrl, getInstUtils } from '../utils/apiServices';
import { ItemIcon, LoadingSpinner, ToLink } from './_Common';
import { getNoCacheLink, getWithExpiry } from '../utils/utilityFunctions';

import './Nav.module.css';
import { useLocation } from 'react-router-dom';

const infoNavSortFunction = (a, b) => a.priority - b.priority;

export function InfoNav({ homePageUrl }) {
  const token = getWithExpiry("token");
  const { pathname } = useLocation();
  const basePath = "/" + pathname.split("/")[1]; // "/Schedule/701" -> "/Schedule"

  const [navItems, setNavItems] = useState([]);
  const [selectedNavItem, setSelectedNavItem] = useState(basePath);

  useEffect(() => {
    (async () => {
      const additionalHeaders = token ? [{ name: 'token', value: token }] : [];

      const { data: fetchedData, error } = await fetchData('/api/InfoLinksItems_New', null, infoNavSortFunction, additionalHeaders);
      setNavItems(fetchedData);
    })();
  }, []);

  return (
    <div className="d-flex flex-wrap btn-group justify-content-center">
      {navItems.map((navItem, index) => (
        <NavItem navItem={navItem} homePageUrl={homePageUrl} isTextResponsive={false} key={index}
          onSelect={(item) => setSelectedNavItem(item.link)}
          isSelected={selectedNavItem === navItem.link} />
      ))}
    </div>
  );
}
export const NavItem = ({ navType, navItem, homePageUrl, isTextResponsive = true, onSelect, isSelected }) => {
  const link = getNoCacheLink(navItem.link);

  const activeCss = !navItem.isLinkNewTab && isSelected ? ' fw-bold text-primary' : '';
  if (navType === "Line")
    return (
      <ToLink to={link} onClick={() => onSelect?.(navItem)} className={`nav-link${activeCss}`} data-bs-toggle="tooltip" title={navItem.text} target={navItem.isLinkNewTab ? '_blank' : '_self'} >
        {navItem.itemIcon && (<ItemIcon itemIcon={navItem.itemIcon} homePageUrl={homePageUrl} />)}
        {navItem.name && <span className="mx-1">{navItem.name}</span>}
      </ToLink>
    )
  else //if (navType === "Buttons")
    return (
      <ToLink to={link} onClick={() => onSelect?.(navItem)} className={`infoNav-fs px-md-3 px-2 text-dark text-decoration-none text-center${activeCss}${isTextResponsive ? " text-responsive" : ""}`} data-bs-toggle="tooltip" title={navItem.text} target={navItem.isLinkNewTab ? '_blank' : '_self'}>
        {navItem.itemIcon && (<ItemIcon itemIcon={navItem.itemIcon} homePageUrl={homePageUrl} />)}
        {navItem.name && (<span className="mx-1 text-decoration-underline">{navItem.name}</span>)}
      </ToLink>
    )
};

export default function Nav(isTextResponsive = true) {
  const [loading, setLoading] = useState(true);

  const [homePageUrl, setHomePageUrl] = useState(null);
  const [navType, setNavType] = useState(null);
  const [navItems, setNavItems] = useState([]);
  const [navItemsMore, setNavItemsMore] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => { setIsOpen(!isOpen); };

  useEffect(() => {
    (async () => {
      const { data: fetchedData, error } = await fetchData('/api/NavItems');
      setNavItems(fetchedData);

      const { data: fetchedDataMore, errorMore } = await fetchData('/api/NavItemsMore');
      setNavItemsMore(fetchedDataMore);

      const fetchedUrl = await getHomePageUrl();
      setHomePageUrl(fetchedUrl);

      const fetchedNavType = await getInstUtils();
      setNavType(fetchedNavType.navType);
    })();

    setLoading(false);
  }, []);

  //if (loading) { return <LoadingSpinner />; }
  return (
    <>
      {navType === "Buttons" &&
        <div className="d-flex flex-wrap justify-content-center">
          {navItems.map((navItem, index) => (
            <NavItem navType={navType} navItem={navItem} homePageUrl={homePageUrl} isTextResponsive={isTextResponsive} key={index} />
          ))}
        </div>}
      {navType === "Buttons" &&
        <div className="d-flex flex-wrap justify-content-center">
          {navItemsMore.map((navItem, index) => (
            <NavItem navType={navType} navItem={navItem} homePageUrl={homePageUrl} isTextResponsive={isTextResponsive} key={index} />
          ))}
        </div>}
      {navType === "Line" &&
        <nav className="navbar navbar-expand-lg navbar-dark py-1 mb-2">
          <button className="navbar-toggler" type="button" onClick={toggle}
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} onClick={toggle}>
            <ul className="list-group rounded-0 border-secondary navbar-nav">
              {navItems.map((navItem, index) => (
                <NavItem navType={navType} navItem={navItem} homePageUrl={homePageUrl} isTextResponsive={isTextResponsive} key={index} />
              ))}
            </ul>
          </div>
        </nav>}
    </>
  );
}